const VARIANT_RETRY_ATTEMPTS = 5;
const VARIANT_RETRY_DELAY_MS = 300;

export const getKameleoonVariantWithRetry = async (
    getVariant: () => Promise<string | null>,
): Promise<string | null> => {
    for (let attempt = 0; attempt < VARIANT_RETRY_ATTEMPTS; attempt++) {
        const variant = await getVariant();
        if (variant !== null) return variant;

        if (attempt < VARIANT_RETRY_ATTEMPTS - 1) {
            await new Promise((resolve) =>
                setTimeout(resolve, VARIANT_RETRY_DELAY_MS),
            );
        }
    }

    return null;
};
